import { render, staticRenderFns } from "./DateChooser.vue?vue&type=template&id=6d565780&scoped=true&"
import script from "./DateChooser.vue?vue&type=script&lang=js&"
export * from "./DateChooser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d565780",
  null
  
)

export default component.exports